
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinshikrapur() {



    const cardData =
    {
        keyword: 'Corporate Cab Services in Shikrapur MIDC ',
        heading: 'etravo : Corporate Cab Services in Shikrapur MIDC ',



"headingDescription": "eTravo provides reliable Corporate Cab Services in Shikrapur MIDC, designed for manufacturing units, logistics companies, and industrial businesses requiring safe, punctual, and efficient employee transportation. With GPS-enabled vehicles, trained chauffeurs, and structured shift-based operations, eTravo ensures smooth daily commuting, factory transfers, and executive travel across the Shikrapur MIDC industrial belt. Flexible monthly and long-term plans make it a dependable mobility solution for industrial operations in the region.",

"top": "Top Industrial Areas for Corporate Cab Services near Shikrapur MIDC with eTravo",

"topPlaces": [
  {
    "title": "Shikrapur MIDC Industrial Area",
    "description": "A growing industrial zone with manufacturing and engineering units requiring daily employee pickup and drop services for shift operations."
  },
  {
    "title": "Chakan MIDC",
    "description": "One of Pune’s largest automotive hubs with major OEMs and suppliers, requiring large-scale corporate transport solutions."
  },
  {
    "title": "Ranjangaon MIDC",
    "description": "A major industrial corridor with multinational companies in automotive and manufacturing sectors needing structured workforce transportation."
  },
  {
    "title": "Sanaswadi Industrial Area",
    "description": "A fast-developing industrial cluster near Pune-Nagar highway with logistics and production units requiring reliable cab services."
  },
  {
    "title": "Lonikand Industrial Zone",
    "description": "An emerging industrial area with warehouses and factories dependent on daily employee transport solutions."
  },
  {
    "title": "Wagholi Industrial Belt",
    "description": "A rapidly expanding commercial and logistics hub with corporate offices and distribution centers requiring regular transport services."
  },
  {
    "title": "Koregaon Bhima Industrial Area",
    "description": "A developing industrial region with manufacturing units and workforce movement requiring consistent cab operations."
  },
  {
    "title": "Pune-Nagar Highway Industrial Corridor",
    "description": "A key industrial stretch connecting multiple MIDC zones, supporting heavy employee and logistics movement."
  },
  {
    "title": "Talegaon MIDC",
    "description": "An established industrial hub with automobile and engineering companies needing structured employee transport services."
  },
  {
    "title": "Bhosari MIDC",
    "description": "One of Pune’s oldest industrial zones with dense manufacturing activity requiring reliable corporate cab services."
  }
],


"services": [
{
"name": "Corporate Cab Shikrapur MIDC",
"description": "eTravo offers dependable corporate cab services in Shikrapur MIDC designed for smooth industrial and business transportation. Our service ensures punctual pickups, comfortable rides, and professional chauffeurs, helping companies maintain efficient daily operations."
},
{
"name": "Taxi Service Shikrapur MIDC",
"description": "Our taxi service in Shikrapur MIDC provides quick and reliable transportation for employees and business professionals. eTravo ensures clean vehicles, timely service, and safe travel across industrial zones and nearby areas."
},
{
"name": "Company Cab Shikrapur MIDC",
"description": "eTravo provides company cab services in Shikrapur MIDC tailored for employee transport and corporate travel. Our solutions ensure reliability, flexibility, and seamless commuting for organizations of all sizes."
},
{
"name": "Industrial Cab Shikrapur",
"description": "eTravo offers specialized industrial cab services in Shikrapur, ensuring efficient transport for workers and executives. Our service supports industrial operations with timely and dependable travel solutions."
},
{
"name": "Employee Transport Shikrapur MIDC",
"description": "Our employee transport services in Shikrapur MIDC are designed for safe and punctual workforce commuting. eTravo provides structured pickup and drop solutions, ensuring smooth daily travel for employees."
},
{
"name": "Office Cab Shikrapur MIDC",
"description": "Simplify daily office commuting with eTravo’s office cab services in Shikrapur MIDC. We provide reliable and comfortable transport for employees traveling between home and workplace."
},
{
"name": "Business Taxi Shikrapur",
"description": "eTravo’s business taxi services in Shikrapur are ideal for meetings, site visits, and daily corporate activities. Our service focuses on punctuality, comfort, and professional travel experiences."
},
{
"name": "Staff Cab Shikrapur MIDC",
"description": "eTravo offers dependable staff cab services in Shikrapur MIDC for daily employee commuting. Our service ensures timely pickups, safe rides, and smooth coordination for workforce mobility."
},
{
"name": "Corporate Travel Shikrapur MIDC",
"description": "Our corporate travel services in Shikrapur MIDC are designed for efficient business transportation. eTravo ensures reliable travel for executives and employees, supporting smooth operations."
},
{
"name": "Factory Transport Shikrapur",
"description": "eTravo provides factory transport services in Shikrapur for industrial workers and staff. Our service ensures safe, timely, and well-organized travel to support factory operations."
},
{
"name": "Company Taxi Shikrapur MIDC",
"description": "eTravo’s company taxi services in Shikrapur MIDC provide flexible and convenient transportation for businesses. Our taxis are ideal for employee travel, client visits, and daily operations."
},
{
"name": "Industrial Cab Hire Shikrapur",
"description": "Choose eTravo’s industrial cab hire in Shikrapur for reliable and efficient transport solutions. Our service supports industrial areas with comfortable vehicles and professional drivers."
},
{
"name": "Corporate Fleet Shikrapur MIDC",
"description": "eTravo offers corporate fleet services in Shikrapur MIDC for businesses requiring multiple vehicles. Our fleet solutions ensure consistent availability, proper maintenance, and smooth operations."
},
{
"name": "Employee Commute Shikrapur MIDC",
"description": "Our employee commute services in Shikrapur MIDC focus on safe and efficient daily travel. eTravo ensures punctual pickups and comfortable rides for a hassle-free commuting experience."
},
{
"name": "Office Transport Shikrapur MIDC",
"description": "eTravo provides office transport services in Shikrapur MIDC for smooth and reliable employee movement. Our service ensures efficient travel management and comfortable commuting for organizations."
}
],
"tableData": [
["Corporate Cab Shikrapur MIDC", "Taxi Service Shikrapur MIDC"],
["Company Cab Shikrapur MIDC", "Industrial Cab Shikrapur"],
["Employee Transport Shikrapur MIDC", "Office Cab Shikrapur MIDC"],
["Business Taxi Shikrapur", "Staff Cab Shikrapur MIDC"],
["Corporate Travel Shikrapur MIDC", "Factory Transport Shikrapur"],
["Company Taxi Shikrapur MIDC", "Industrial Cab Hire Shikrapur"],
["Corporate Fleet Shikrapur MIDC", "Employee Commute Shikrapur MIDC"],
["Office Transport Shikrapur MIDC", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Dedicated Corporate Cab Services in Shikrapur MIDC",
      "WhyChoosedescription": "eTravo offers reliable corporate cab services in Shikrapur MIDC, ensuring smooth and efficient employee transportation for industries located in the rapidly growing Shirur industrial belt near Pune."
    },
    {
      "WhyChooseheading": "Strategic Industrial Connectivity",
      "WhyChoosedescription": "Shikrapur is a major industrial and growth hub in Pune district with excellent connectivity via the Pune–Ahmednagar highway and nearby MIDC zones like Ranjangaon and Sanaswadi. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Ideal for Factory and Corporate Workforce Transport",
      "WhyChoosedescription": "Our services are designed for manufacturing units, IT support offices, and industrial staff, providing daily commute solutions tailored for shift-based operations."
    },
    {
      "WhyChooseheading": "Wide Fleet for Industrial and Executive Travel",
      "WhyChoosedescription": "We offer a diverse fleet including hatchbacks, sedans, SUVs, and employee transport vehicles suitable for both workforce mobility and management-level travel."
    },
    {
      "WhyChooseheading": "Efficient Route Planning for MIDC Areas",
      "WhyChoosedescription": "With optimized routes and scheduling, we ensure timely pickups and drop-offs even in high-traffic industrial zones, improving operational efficiency."
    },
    {
      "WhyChooseheading": "Experienced Drivers for Industrial Routes",
      "WhyChoosedescription": "Our chauffeurs are familiar with Shikrapur MIDC, Sanaswadi, and Ranjangaon routes, ensuring safe and timely employee transportation."
    },
    {
      "WhyChooseheading": "Flexible Corporate Contracts and Monthly Plans",
      "WhyChoosedescription": "eTravo provides customizable packages including daily pickup-drop, shift-based transport, and long-term contracts for industrial clients."
    },
    {
      "WhyChooseheading": "24/7 Support for Industrial Transport Needs",
      "WhyChoosedescription": "Our support team operates round the clock to manage bookings, shift changes, and emergency travel requirements, ensuring uninterrupted business operations."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is corporate cab service in Shikrapur MIDC?',
            answer: 'Corporate cab service in Shikrapur MIDC provides organized transportation for employees working in industrial and manufacturing units in the area.',
        },
        {
            question: 'Where is Shikrapur MIDC located?',
            answer: 'Shikrapur is located in Shirur taluka of Pune district and is well connected via major highways like NH753F, making it easily accessible from Pune city. :contentReference[oaicite:1]{index=1}',
        },
        {
            question: 'Do you provide employee transport for factories in Shikrapur MIDC?',
            answer: 'Yes, eTravo offers daily pickup and drop services for factory workers and corporate staff with fixed routes and schedules.',
        },
        {
            question: 'Can shift-based transportation be arranged for MIDC employees?',
            answer: 'Yes, we provide transportation for day, night, and rotational shifts based on industrial requirements.',
        },
        {
            question: 'What types of vehicles are available for corporate transport?',
            answer: 'We provide hatchbacks, sedans, SUVs, and larger vehicles depending on employee strength and travel needs.',
        },
        {
            question: 'Are drivers experienced in MIDC routes?',
            answer: 'Yes, our drivers are trained and experienced in handling industrial routes and ensuring timely travel.',
        },
        {
            question: 'Do you provide monthly contracts for companies in Shikrapur MIDC?',
            answer: 'Yes, we offer cost-effective monthly and long-term corporate transport contracts tailored for businesses.',
        },
        {
            question: 'Is the service available 24/7 in Shikrapur MIDC?',
            answer: 'Yes, our services are available round the clock to support all industrial shift timings.',
        },
        {
            question: 'Do you provide GST billing for corporate services?',
            answer: 'Yes, we provide GST-compliant invoices for all corporate bookings.',
        },
        {
            question: 'How can I book corporate cab services in Shikrapur MIDC?',
            answer: 'You can book through our website or contact our corporate support team for customized industrial transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Vijay Kale',
        designation: 'Production Manager, Automotive Industry, Shikrapur MIDC',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has made employee transportation in Shikrapur MIDC extremely smooth. Their punctual service and route management are perfect for industrial operations.”',
    },
    {
        name: 'Ms. Neha Patankar',
        designation: 'HR Manager, Manufacturing Unit, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for workforce transport in Shikrapur MIDC. Their flexibility and reliable service ensure hassle-free commuting for our employees.”',
    },
];










    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Shikrapur MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-shikrapur-midc.jpg",
  "description": "Reliable corporate cab services in Shikrapur MIDC by eTravo. Ideal for employee transport, factory staff commute, office pickup and drop, and industrial area travel with safe and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-shikrapur-midc"
  }
};








    return (
        <div>

<Helmet>
  <title>Corporate Cab Services in Shikrapur MIDC | Industrial & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services in Shikrapur MIDC with eTravo for employee transport, factory staff commute, office pickup and drop, and industrial travel needs. Safe and reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/129.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinshikrapur;